module.exports = __webpack_public_path__ + "static/HF_AZXY5-f423e7fd90d91f04a859bd5f2582f204.png";